export const getGeographicMidpoint = (points) => {
  if (!points.length) return null

  let x = 0, y = 0, z = 0

  points.forEach(([lat, lng]) => {
    const latRad = (lat * Math.PI) / 180
    const lngRad = (lng * Math.PI) / 180

    x += Math.cos(latRad) * Math.cos(lngRad)
    y += Math.cos(latRad) * Math.sin(lngRad)
    z += Math.sin(latRad)
  })

  const totalPoints = points.length

  x /= totalPoints
  y /= totalPoints
  z /= totalPoints

  const lng = Math.atan2(y, x)
  const hyp = Math.sqrt(x * x + y * y)
  const lat = Math.atan2(z, hyp)

  return [
    (lat * 180) / Math.PI,
    (lng * 180) / Math.PI
  ]
}
